module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-2-photo-10-14926421e5cd056502789891428adc1f.webp";